import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import EyeOutlinedSvg from "@ant-design/icons-svg/es/asn/EyeOutlined";
import AntdIcon from "../components/AntdIcon";
var EyeOutlined = function EyeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EyeOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(EyeOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'EyeOutlined';
}
export default RefIcon;